import Base from '@ali/aliyun-business/lib/base';

import * as Service from './service';
import commonBuy from '../commonbuy/buy';

const { warning } = window.DN.Modal;
function showModal(content, text1, link1, text2, link2) {
  const data = {
    title: content.title,
    content: content.message,
    button: [
      {
        text: text1,
        link: link1,
        style: 'ghost'
      }

    ]
  };
  if (text2) {
    data.button.push({
      text: text2,
      link: link2
    });
  }
  warning(data);
}
let errorInfo = []; //报错文案存储的地方
Service.fetchError_text()
  .then((res) => {
    errorInfo = res.data;
  });
// 页面刚加载时获取基础信息
Service.get_config_info('aliyun_index.cloudpartner.pt_yuntongxin.config_file')
  .then(res => {
    const result = res.data;
    window.__config_data_base = result;
    $('body').trigger('__config_data_base_info', result);
  });
// 等待基础信息和错误信息获取完毕
async function basicInfoHasReady() {
  return new Promise(resolve => {
    if (errorInfo.length >= 0 && window.__config_data_base) {
      resolve(true);
    } else {
      const id = setInterval(() => {
        if (errorInfo.length >= 0 && window.__config_data_base) {
          resolve(true);
          clearInterval(id);
        }
      }, 100);
    }
  });
}
function switchModal(code, msg) {
  switch (code) {
    case 'notLoginError':
      showModal(getErroeMsg('notLoginError'),
        '注册', Base.getRegisterUrl(location.href),
        '登录', Base.getLoginUrl(location.href));
      $('.dn-dialog-footer').find('a').prop('target', '_self');
      break;
    case 'certifiedError':
      const realUrl = window.innerWidth <= 768 ? 'https://account.console.aliyun.com/h5/certify' : Base.getRealUrl();
      showModal(getErroeMsg('certifiedError'),
        '关闭', 'javascript:void(0)',
        '去认证', realUrl);
      // $('.dn-dialog-footer').find('a').prop('target', '_self');
      break;
    case 'enterpriseCertifiedError':
      showModal(getErroeMsg('enterpriseCertifiedError'),
        '关闭');
      break;
    case 'ambassadorApplyError':
      showModal(getErroeMsg('ambassadorApplyError'),
        '关闭');
      break;
    default:
      showModal(getErroeMsg(code, msg), '关闭');
  }
}


/**
 * @param {*} code 错误code
 */
function getErroeMsg(code, msg) {
  for (let i = 0, l = errorInfo.length; i < l; i++) {
    if (errorInfo[i].errorCode == code) {
      console.log(msg)
      return errorInfo[i];
    }
  }
  return {
    message: msg || "出错了",
    title: '提示'
  };
}

window.config_func = {
  fetchBasicInfo: async () => {
    await basicInfoHasReady();
    return window.__config_data_base;
  },
  onganize: async function () {     // 组队
    Service
      .open_reg()
      .then((result) => {
        if (result.code == 200) {
          // 有队伍了，可以跳转
          const buyCode = result.data.buyCode;
          location.href = `//promotion.aliyun.com/ntms/act/${window.__config_data_base.link_type}/team.html?group=${buyCode}`; // 组队成功后跳转至组长页
        } else {
          switchModal(result.code, result.msg);
        }
      });
  },
  buy: function (groupCode, basicInfo, id) { // 购买
    return Service
      .validateQualification(groupCode)
      .then((result) => {
        // 这里写rds的售卖逻辑
        console.log(basicInfo);
        if (result.code == 200) {
          // 有队伍了，可以跳转
          commonBuy(groupCode, basicInfo);
          return result.code;
        } else {
          switchModal(result.code, result.msg);
          return result.code;
        }
      });
  },
  end_fetch_buyCode: function (cb) {   // 结束页获取buyCode
    //   })
    Service.open_reg()
      .then((result) => { 
        if (result.code == 200) {
          const buyCode = result.data.buyCode;
          cb(buyCode);
        } else {
          switchModal(result.code, result.msg);
        }
      });
  },
  getLeaderData: function (groupId, cb) { // 获取组队的信息
    Service.fetch_group(groupId)
      .then((result) => {
        cb(result);
      });
  },
  extend_group: function (cb) { // 推广
    Service.open_reg()
      .then((result) => {
        if (result.code == 200) {
          cb(result);
        } else {
          switchModal(result.code, result.msg);
        }
      });
  },
  get_groupId: function (cb) { //获取groupId
    Service.open_reg()
      .then((result) => {
        if (result.code == 200) {
          const buyCode = result.data.buyCode;
          cb(buyCode);
        } else {
          switchModal(result.code, result.msg);
        }
      });
  },
  get_buyCode: function (cb) { //获取groupId
    Service.open_reg()
      .then((result) => {
        if (result.code == 200) {
          cb(1);
        } else {
          cb(0);
          switchModal(result.code, result.msg);
        }
      });
  },
  get_groupInfo: function (groupId, cb) {
    Service.fetch_group(groupId)
      .then((result) => {
        if (result.code == 200) {
          const paidCount = result.data.paidCount;// 已支付人数
          cb(paidCount);
        } else {
          switchModal(result.code, result.msg);
        }
      });
  }
};



// WEBPACK FOOTER //
// ./src/ytx/index.js